// routes
import { PATH_CoE, PATH_HelpAndCommunication } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AppCache from '../../../services/appcache';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    dataUpload: icon('ic_dataupload'),
    dataMapping: icon('ic_mapping'),
    noneligibleRecords: icon('ic_noneligible'),
    enablereupload: icon('ic_reupload'),
    dealerrequest: icon('ic_request'),
    master: icon('ic_master'),
    report: icon('ic_chart'),
    reprocess: icon('ic_reprocess'),
    raiseticket: icon('ic_raiseticket'),
    helpdesk: icon('communication'),
    data: icon('ic_data'),
};
// const isHnCActive = AppCache?.GetCurrentLoggedInUser()?.IsHnCActive;

const userRole = AppCache?.GetCurrentLoggedInUser()?.UserRoleName;

const userDetails = AppCache.GetUserLoginDetails();
const hasZylemFranchise = userDetails?.Franchise?.split(',')
    .some(f => f.trim().toUpperCase() === 'ETHICON' || f.trim().toUpperCase() === 'ENDO');

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
            { title: 'Data Upload Status', path: PATH_CoE.dataUploadApprove, icon: ICONS.dataUpload },
            ...(hasZylemFranchise ? [
                { title: 'Reload Zylem Data', path: PATH_CoE.reloadzylemdata, icon: ICONS.reprocess },
                { title: 'Data Mapping', path: PATH_CoE.datamapping, icon: ICONS.dataMapping }
            ] : []),
            { title: 'Enable Reupload', path: PATH_CoE.enablereupload, icon: ICONS.enablereupload },
            // { title: 'Dealer Request ', path: PATH_CoE.dealerrequest, icon: ICONS.dealerrequest },
            /* { title: 'Noneligible Records ', path: PATH_CoE.noneligiblerecordsapprove, icon: ICONS.noneligibleRecords},    */
            // { title: 'Dealer Ticket', path: PATH_CoE.raiseticketrequest, icon: ICONS.raiseticket },
            // { title: 'Data Upload ', path: PATH_CoE.dataupload, icon: ICONS.dataUpload },
            { title: 'Configuration', path: PATH_CoE.configuration, icon: ICONS.master, },
            // { title: 'System Configuration ', path: PATH_CoE.cutoffdatepage, icon: ICONS.master },
            { title: 'System Configuration ', path: PATH_CoE.franchisewisecutoff, icon: ICONS.master },

            { title: 'Help and Communication', path: PATH_HelpAndCommunication.helpandcommunication('JJ Core'), opneinnewtab: true, icon: ICONS.helpdesk },
            {
                title: 'Masters', path: PATH_CoE.master.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor', path: PATH_CoE.master.distributor },
                    { title: 'Products', path: PATH_CoE.master.product },
                    { title: 'ECP Product', path: PATH_CoE.master.ecpproduct },
                    { title: 'Standard Price', path: PATH_CoE.master.standardpricemaster },
                    { title: 'Accounts', path: PATH_CoE.master.account },
                    { title: 'Area Tree', path: PATH_CoE.master.areatree },
                    // { title: 'Sales Hierarchy', path: PATH_CoE.master.saleshierarchy },
                    // { title: 'Sales Hierarchy', path: PATH_CoE.master.saleshierarchy },
                    { title: 'Surgeons', path: PATH_CoE.master.surgeon },
                    // { title: 'Net Realization Rate', path: PATH_CoE.master.netrealizationrate },
                    { title: 'Employee', path: PATH_CoE.master.empmaster },
                    { title: 'Territory', path: PATH_CoE.master.territory },
                    { title: 'Employee Territory', path: PATH_CoE.master.empterritory },
                    { title: 'Territory Management', path: PATH_CoE.master.accountterritory },
                    // { title: 'Employee Region', path: PATH_CoE.master.empregion },
                    { title: 'Branch Secretary Region', path: PATH_CoE.master.empregion },
                    // { title: 'Account Territory', path: PATH_CoE.master.accountterritory },
                    { title: 'Distributor Territory', path: PATH_CoE.master.distributorterritory },
                    { title: 'Territory Hierarchy', path: PATH_CoE.master.territoryhierarchy },
                    { title: 'Organization Group ', path: PATH_CoE.master.orggroupdefinition },
                    { title: 'Dealer Agreement', path: PATH_CoE.master.dealeragreementexpiry },
                    { title: 'Dealer Rating ', path: PATH_CoE.master.dealerrating },
                    { title: 'Distributor Billing Software', path: PATH_CoE.master.distributorbillingsoftware },
                    // { title: 'Field Staff Allocation', path: PATH_MAIN.master.fieldstaffallocation },
                    // { title: 'Product Variant', path: PATH_CoE.master.productvariant },
                    { title: 'Customer', path: PATH_CoE.master.customers },
                    { title: 'Customer Account', path: PATH_CoE.master.customeraccount },
                    // { title: 'User', path: PATH_CoE.master.usermasterlist },
                    // { title: 'Customer Sales Team', path: PATH_MAIN.master.customersalesteam },
                    // { title: 'User Access Rights', path: PATH_MAIN.master.useraccessrights },
                ],
            },
            {
                title: 'Allied Master', path: PATH_CoE.alliedmaster.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor Group', path: PATH_CoE.alliedmaster.distributorgroup },
                    { title: 'UOM', path: PATH_CoE.alliedmaster.uom },
                    { title: 'Franchise', path: PATH_CoE.alliedmaster.franchise },
                    { title: 'Sub Franchise', path: PATH_CoE.alliedmaster.subfranchise },
                    { title: 'Product Group', path: PATH_CoE.alliedmaster.productgroup },
                    { title: 'Product category', path: PATH_CoE.alliedmaster.productcategory },
                    { title: 'Product Brand', path: PATH_CoE.alliedmaster.productbrand },
                    { title: 'Product Line', path: PATH_CoE.alliedmaster.productline },
                    { title: 'Account Group', path: PATH_CoE.alliedmaster.accountgroup },
                    { title: 'Account Type', path: PATH_CoE.alliedmaster.accounttype },
                    { title: 'Account Classification', path: PATH_CoE.alliedmaster.accountclassification },
                    { title: 'Account Segmentation', path: PATH_CoE.alliedmaster.accountsegmentation },
                    { title: 'Account Category', path: PATH_CoE.alliedmaster.accountcategory },
                    { title: 'Surgeon Contact Type', path: PATH_CoE.alliedmaster.surgeoncontacttype },
                    { title: 'Surgeon Sub Contact Type', path: PATH_CoE.alliedmaster.surgeonsubcontacttype },
                    { title: 'City Tier', path: PATH_CoE.alliedmaster.citytier },
                    { title: 'Employee Level', path: PATH_CoE.alliedmaster.emplevel },
                    { title: 'Specialist', path: PATH_CoE.alliedmaster.specialist },
                    { title: 'Bravo Hierarchy', path: PATH_CoE.alliedmaster.bravohierarchy },
                    // { title: 'Territory', path: PATH_CoE.alliedmaster.territory },

                ],
            },
            {
                title: 'Data', path: PATH_CoE.data.root, icon: ICONS.data,
                children: [
                    { title: 'Inventory', path: PATH_CoE.data.inventorypage },
                ],
            },
            // {
            //    title: 'My Report', path: PATH_CoE.myreport.root, icon: ICONS.dataUpload,
            //    children: [

            //    ],
            // },
            {
                title: 'Report', path: PATH_CoE.report.root, icon: ICONS.report,
                children: [
                    { title: 'Dealer Data Status Report', path: PATH_CoE.report.dealerdatastatusreportpage },
                    { title: 'Dealer Reported Sales', path: PATH_CoE.report.transactionreportpage },
                    { title: 'Dealer Reported SNS', path: PATH_CoE.report.dealerreportedsnsreportpage },
                    { title: 'Dealer Price Report', path: PATH_CoE.report.dealerreportpage },
                    // { title: 'Dump Report', path: PATH_CoE.report.dumpreportpage },
                    { title: 'Dump Report', path: PATH_CoE.report.territorydumpreportpage },
                    { title: 'Dealer Purchase Report', path: PATH_CoE.report.dealerpurchasereportpage },
                    { title: 'Activity Log', path: PATH_CoE.report.activitylogpage },
                    { title: 'Inventory Report', path: PATH_CoE.report.inventoryreportpage },
                    // { title: 'Dealer SNS Report', path: PATH_CoE.report.dealersnsreportpage },
                    // { title: 'Gross Sales Report', path: PATH_CoE.report.grosssalesreportpage },
                    ...(userRole !== 'COE Viewer'
                        ? [
                            { title: 'Standard Price Report', path: PATH_CoE.report.standardpricereportpage },
                            //  { title: 'Module Role Access List', path: PATH_CoE.report.moduleroleaccesslistpage },
                        ] : []
                    ),
                    { title: 'Request Report', path: PATH_CoE.report.ytddumpreportpage },
                ],
            },
        ],
    }
];

export default navConfig;